import styled from 'styled-components';

export const corDeFundoPrincipal = '#DEECE1';

export const ContactContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7rem; 
  padding: 7rem;
  flex-wrap: wrap;
  background-color: ${corDeFundoPrincipal};
`;

export const ContactCard = styled.div`
  background-color: #2f9e44;
  color: white;
  padding: 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 300px;
`;

export const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const Text = styled.p`
  font-size: 0.8rem;
  line-height: 1.2rem;
  margin-bottom: 1.5rem;
  opacity: 0.9;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const Button = styled.button`
  width: 100%;
  background-color: #fbbf24;
  color: black;
  font-weight: 600;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f59e0b;
  }
`;


export const SideContent = styled.aside`
  color: #1f2937;
`;

export const Kicker = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  font-weight: 700;
  color: #2f9e44;
  background: #eaf6ee;
  padding: 0.25rem 0.5rem;
  border-radius: 0.4rem;
  border: 1px solid #2f9e44;
  margin-bottom: 0.75rem;
`;

export const SideTitle = styled.h4`
  font-size: 1.25rem;
  font-weight: 800;
  margin: 0.25rem 0 1rem;
`;

export const SideP = styled.p`
  margin-bottom: 1rem;
  font-weight:600;
  color: #374151;
  
`;

export const SideList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 1.25rem;

  li {
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
    margin-bottom: 0.5rem;
    line-height: 1.8;
  }
  li::before {
    content: "✓";
    font-weight: 700;
    margin-top: 0.15rem;
    color: #2f9e44;
  }
`;

export const Note = styled.p`
  font-size: 0.875rem;
  color: #4b5563;
  background: #f3fdf6;
  border: 1px solid #e6f6ea;
  padding: 0.75rem 0.9rem;
  border-radius: 0.5rem;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
  width: 1.5rem;
  height: 1.5rem;
    path, circle {
      fill: #2f9e44;
      stroke: white;
      stroke-width: 1.7px; 
    }
  }
`;